import { useState, createContext, useMemo, useCallback } from 'react';
import { Typography } from '@mui/material';
import { ConfirmDialog } from '../components';

const AlertBoxContext = createContext({
  alert: { open: false, message: '' },
  setAlert: () => {},
});

const AlertBoxContextProvider = ({ children, user }) => {
  const [alert, setAlert] = useState({
    open: false,
    message: '',
  });

  const onCloseAlert = useCallback(() => {
    setAlert({
      open: false,
      message: '',
    });
  }, []);

  const value = useMemo(() => ({ alert, setAlert }), [alert]);

  return (
    <AlertBoxContext.Provider value={value}>
      <ConfirmDialog
        open={alert.open}
        onClose={onCloseAlert}
        onConfirm={onCloseAlert}
        title="Alert"
        subtitle="A360"
        confirmText="OK"
        showCancelButton={false}
        disableBackdropClose>
        {user?.first_name ? (
          <Typography variant="body2" component="p" sx={{ mb: 1 }}>
            Hey {user.first_name},
          </Typography>
        ) : null}
        <Typography variant="body2" component="p">
          {alert.message}
        </Typography>
      </ConfirmDialog>
      {children}
    </AlertBoxContext.Provider>
  );
};

export { AlertBoxContext, AlertBoxContextProvider };
